import { Routes } from '@angular/router';

export const ContactsRoutes: Routes = [

];
